import magnifiAPIInstance from "./apiInstance";

export const centraliseStorageAPIs = {
  getStorageList: () => magnifiAPIInstance.post("/get-storage-list"),
  createStorageList: ({ payload }) => magnifiAPIInstance.post("/storage-list-create", payload),
  validateStorage: ({ payload }) => magnifiAPIInstance.post("/validate_storage", payload),
  editStorageList: ({ payload }) => magnifiAPIInstance.post("/storage-list-edit", payload),
};
